<template>
  <sk-error-page></sk-error-page>
</template>
<script>
export default {
  props: [],
  components: {},
  data() {
    return {}
  },
  watch: {},
  computed: {},
  mounted() {},
  created() {},
  filters: {},
  methods: {}
}
</script>
